import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Checkbox, Spin, Empty, Flex, Popover, Radio } from "antd";
import _ from "lodash";
import { httpApi } from "api/http.api";

interface Tag {
    id: number;
    name: string;
    // Add other properties from your API response here
}

const TagList: React.FC<any> = ({ onSelect, selectedTags, isRadio, placeholder = "Start Typing Tag Name" }) => {
    const [tags, setTags] = useState<Tag[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    // const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [totalPages, setTotalPages] = useState<number | null>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [cancelToken, setCancelToken] = useState<any | null>(null);

    const fetchData = async () => {
        //if (loading) return;

        try {
            const response = await httpApi.get(`/ats/tag`, {
                params: { search: searchQuery, page },
            });
            setLoading(false);
            setTags((prevTags) =>
                _.uniqBy([...prevTags, ...response.data.results], "name")
            );
            console.log("Loading..3.");
            setTotalPages(response.data.total_pages);
        } catch (error) {
            console.log("Loading.22222..");
            if (axios.isCancel(error)) {
                window.location.href = "/403";
                // Request was canceled, do nothing
            } else {
                console.error("Error fetching data:", error);
            }
        } finally {
            console.log("Loading.33..");
            setLoading(false);
        }
    };

    const fetchQueryData = async () => {
        //if (loading) return;

        console.log("Loading...");
        if (cancelToken) {
            // If there's a previous request, cancel it before making a new one
            cancelToken.cancel("New request initiated");
        }
        console.log("Loading..2.");
        const newCancelToken = axios.CancelToken.source();
        setCancelToken(newCancelToken);

        try {
            const response = await httpApi.get(`/ats/tag`, {
                params: { search: searchQuery, page },
                cancelToken: newCancelToken.token, // Provide the cancel token for this request
            });
            setLoading(false);
            setTags((prevTags) =>
                _.uniqBy([...prevTags, ...response.data.results], "name")
            );
            console.log("Loading..3.");
            setTotalPages(response.data.total_pages);
        } catch (error) {
            console.log("Loading.22222..");
            if (axios.isCancel(error)) {
                window.location.href = "/403";
                // Request was canceled, do nothing
            } else {
                console.error("Error fetching data:", error);
            }
        } finally {
            console.log("Loading.33..");
            setLoading(false);
        }
    };

    // Clear old results when searchQuery changes
    useEffect(() => {
        setTags([]);
        setPage(1);
    }, [searchQuery]);

    useEffect(() => {
        console.log(loading);
        fetchData();
    }, [page]);

    useEffect(() => {
        console.log(loading);
        fetchQueryData();
    }, [searchQuery]);

    const handleScroll = () => {
        const list = document.getElementById("tag-list");
        if (list && list.clientHeight + list.scrollTop + 5 >= list.scrollHeight) {
            if (totalPages === null || page < totalPages) {
                setLoading(true);
                setTimeout(() => {
                    setPage(page + 1);
                }, 100);
            }
        }
    };

    useEffect(() => {
        const list = document.getElementById("tag-list");
        if (list) {
            list.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (list) {
                list.removeEventListener("scroll", handleScroll);
            }
        };
    }, [page, totalPages]);

    return (
        <Flex vertical gap={20} className="mt-5">
            <Input
                type="text"
                placeholder={placeholder}
                value={searchQuery}
                size="large"
                onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div
                id="tag-list"
                style={{ height: "225px", overflowY: "auto", marginTop: "10px" }}
            >
                {tags.length > 0 ? (
                    tags.map((tag, index) => (
                        <p key={tag.name + index} style={{ marginBottom: "5px", fontWeight: 500 }}>
                            {isRadio ?
                                <Radio
                                    onChange={() => onSelect(tag.name)}
                                    checked={selectedTags && selectedTags === tag.name}
                                    className="font-normal"
                                >
                                    {tag.name}
                                </Radio>
                                : <Checkbox
                                    className="font-normal"
                                    onChange={() => onSelect(tag.name)}
                                    checked={selectedTags.includes(tag.name.toString())}
                                >
                                    {tag.name}
                                </Checkbox>}
                        </p>
                    ))
                ) : !loading ? (
                    <Empty description="No Records Found" />
                ) : (
                    ""
                )}
                {loading ? (
                    <div
                        style={{ margin: "auto", textAlign: "center", marginTop: "10px" }}
                    >
                        <Spin size="small" />
                    </div>
                ) : (
                    ""
                )}
            </div>

        </Flex>
    );
};

export default TagList;
